module.exports = __webpack_public_path__ + "static/media/webpay-plus.bbb87741.png";